import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from './actions';
import Tooltip from 'components/atoms/tooltip';
import {getSubjectBySport} from './helpers';

class RelaxBuildRules extends Component {
    onClick(isChecked) {
        this.props.dispatch(Action.set('RelaxBuildRules', isChecked));
    }

    canComponentBeRendered() {
        const {sportConfig} = this.props;

        return sportConfig.isModeLateswap();
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return null;
        }

        const {sportConfig, settings, className = ''} = this.props;

        const isChecked = settings.isRelaxBuildRulesUsed();

        return (
            <div className={className}>
                <div className="input-info top-info">
                    <Tooltip subject={getSubjectBySport(sportConfig.getSport())} />
                    <div className="checkbox">
                        <label>
                            <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={(e) => ::this.onClick(e.target.checked)}
                            />
                            Relax build rules
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        lineupGenerator: {settings},
    } = state;

    return {
        sportConfig,
        settings,
    };
}

export default connect(mapStatesToProps)(RelaxBuildRules);
